import emma from "../services/Emma";
import { resolveDate } from "../services/ResolveDate";

const EstateResource = {
  getPatrimonial(dispatch, estate, id = null) {
    return new Promise((resolve, reject) => {
      emma
        .get("api/estate/private/" + (id || estate.idUser))
        .then((data) => {
          dispatch("storePatrimonial", {
            name: "SET_ID",
            data: {
              id: id || estate.idUser,
            },
            fromStart: true,
          });
          if (
            data.status === 200 &&
            data.statusText === "OK" &&
            data.data.success
          ) {
            const d = data.data.user;
            const summEstate = data.data.private_estate_totals;
            const details = data.data.private_estate_details;
            dispatch("storePatrimonial", {
              name: "UPDATED_AT",
              data: {
                updatedAt: details.updated_at,
                completedAt: details.completed_at,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "TOTAL",
              data: {
                incomes: summEstate.total_incomes,
                loans: summEstate.total_loans,
                savings: summEstate.total_savings,
                immobilier: summEstate.immobilier,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "YOUR_INFORMATIONS",
              data: {
                birthdate: d.birthdate ? d.birthdate.substring(0, 10) : null,
                job: d.job,
                csp: d.professional_category,
                maritalStatus: d.relationship_status,
              },
              fromStart: true,
            });
            const kids = d.kids.map((kid) => {
              return {
                id: kid.id,
                type: kid.type,
                firstname: kid.firstname,
                lastname: kid.lastname,
                dateOfBirth: kid.birthdate.substring(0, 10),
              };
            });
            dispatch("storePatrimonial", {
              name: "YOUR_HOME",
              data: kids,
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "ANNUAL_RECIPE",
              data: {
                directIncome: {
                  val: d.main_income,
                  cur: d.main_income_currency,
                },
                secondIncome: {
                  val: d.unearned_income,
                  cur: d.unearned_income_currency,
                },
              },
              fromStart: true,
            });
            const srs = d.secondary_residences.map((se) => {
              return {
                id: se.id,
                ownership_type: se.ownership_type,
                cur: se.currency,
                value: se.value,
              };
            });
            const rentalProperties = d.rental_properties.map((rp) => {
              return {
                id: rp.id,
                ownership_type: rp.ownership_type,
                cur: rp.currency,
                value: rp.value,
              };
            });
            dispatch("storePatrimonial", {
              name: "REAL_ESTATE",
              data: {
                mainEstate: {
                  val: d.main_residence_value,
                  cur: d.main_residence_value_currency,
                  type: d.main_residence_ownership,
                },
                secondaryEstates: srs,
                rentalProperties: rentalProperties,
                isSCPI: d.scpi_shares_owner,
                scpi: {
                  value: d.scpi_shares_value,
                  cur: d.scpi_shares_value_currency,
                  type: d.scpi_shares_ownership,
                },
              },
              fromStart: true,
            });
            const savings = d.savings.map((saving) => {
              let s = {
                type: null,
                fields: {},
              };
              s.type = saving.saving_type;
              Object.keys(saving).map((key) => {
                if (key !== "saving_type" && saving[key] !== null) {
                  s.fields[key] = saving[key];
                }
              });
              return s;
            });
            dispatch("storePatrimonial", {
              name: "SAVINGS",
              data: savings,
              fromStart: true,
            });
            // dispatch('storePatrimonial', {
            // 	name: 'GFR',
            // 	data: {
            // 		nbObjects: d.art_possession,
            // 		isMetals: d.precious_metal,
            // 		isReceivables: d.monies_outstanding,
            // 		isOtherEstates: d.other_realestate
            // 	},
            // 	fromStart: true
            // })
            dispatch("storePatrimonial", {
              name: "SPENDING_NO_TAXES",
              data: {
                spending: {
                  value: d.expenses_amount,
                  cur: d.expenses_amount_currency,
                },
                periodicity: d.expenses_frequency,
              },
              fromStart: true,
            });
            let loans = d.loan.map((l) => {
              return {
                id: l.id,
                type: l.loan_type,
                value: l.value,
                currency: l.currency,
                monthlyPayment: l.monthly_payment,
              };
            });
            console.log("before dispatch credits", d);
            dispatch("storePatrimonial", {
              name: "CREDITS",
              data: {
                loans: loans,
                overallDebtPercentage: d.overall_debt_percentage,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "TAXES",
              data: {
                value: d.income_tax,
                cur: d.income_tax_currency,
                nbFiscalParts: d.isf_household_share,
                countryForTaxes: d.isf_affiliated_country,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "ISF",
              data: {
                amount: d.isf_tax,
                cur: d.isf_tax_currency,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "RETREAT",
              data: {
                month: d.retirement_month,
                year: d.retirement_year,
                hasRetirement: d.has_retirement,
                PERP: d.perp_type,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "INFLUENCE",
              data: {
                motivation: d.profile_influence_description,
                conselors: d.profile_influence_persons,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "FOLLOWING",
              data: {
                rate: d.profile_follow_advice,
                nbContractCounselor: d.profile_follow_contract_persons,
                nbPatrimonialCounselor: d.profile_follow_asset_persons,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "KNOWLEDGE",
              data: {
                diploma: d.profile_knowledge_diploma,
                level: d.profile_knowledge_level,
                age: d.profile_knowledge_age,
                country: d.profile_knowledge_country,
                products: d.profile_knowledge_product,
                investedProducts: d.profile_knowledge_invested_product,
                managements: d.profile_knowledge_management,
              },
              fromStart: true,
            });
						dispatch("storePatrimonial", {
              name: "ESG",
              data: {
								interestedBySustainability: d.interested_by_sustainability,
								acceptLowerPerformance: d.durability_perf,
								durabilite: d.durability,
              },
              fromStart: true,
            });
            dispatch("storePatrimonial", {
              name: "PERSPECTIVE",
              data: {
                perspective: d.profile_investment_perspectives,
                objective: d.profile_investment_objectives,
                riskDegree: d.profile_risk_degree,
                risingMarket: d.profile_rising_market,
                assetsEstimate: d.profile_assets_estimate,
                investmentsEstimate: d.profile_investment_estimate,
              },
              fromStart: true,
            });
            console.log("before dispatch advisor_check", d);
            dispatch("storePatrimonial", {
              name: "ADVISOR_CHECK",
              data: {
                advisorConsistencyCheck: d.advisor_consistency_check,
                advisorCompletenessCheck: d.advisor_completeness_check,
                advisorWarningSentToClient: d.advisor_warning_sent_to_client,
              },
              fromStart: true,
            });
          }
          resolve();
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  savePatrimonial(dispatch, estate, id) {
    return new Promise((resolve, reject) => {
      this.saveMainPatrimonial(estate)
        .then(() => {
          return Promise.all([
            this.saveKids(estate),
            this.saveSecondaryEstates(estate),
            this.saveRentalProperties(estate),
            this.saveSavings(estate),
            this.saveLoans(estate),
            this.savePatrimonialArray(estate),
          ]);
        })
        .then(() => {
          return this.getPatrimonial(dispatch, estate, id);
        })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          console.warn(error);
          reject(error);
        });
    });
  },
  saveMainPatrimonial(data) {
    const u = data;
    const d = new FormData();
    if (u.birthdate) {
      d.append("birthdate", resolveDate(u.birthdate));
    }
    d.append("job", u.job);
    d.append("professional_category", u.csp);
    d.append("relationship_status", u.maritalStatus);
    d.append("main_income", u.directIncome.val);
    d.append("main_income_currency", u.directIncome.cur);
    d.append("unearned_income", u.secondIncome.val);
    d.append("unearned_income_currency", u.secondIncome.cur);
    d.append("main_residence_owner", u.mainEstate.val > 0);
    d.append("main_residence_value", u.mainEstate.val);
    d.append("main_residence_value_currency", u.mainEstate.cur);
    d.append("main_residence_ownership", u.mainEstate.type);
    d.append("scpi_shares_owner", u.isSCPI ? 1 : 0);
    d.append("scpi_shares_value", u.scpi.value);
    d.append("scpi_shares_value_currency", u.scpi.cur);
    d.append("scpi_shares_ownership", u.scpi.type);
    // d.append('art_possession', u.gfr.nbObjects)
    // d.append('precious_metal', (u.gfr.isMetals) ? 1 : 0)
    // d.append('other_realestate', (u.gfr.isOtherEstates) ? 1 : 0)
    // d.append('monies_outstanding', (u.gfr.isReceivables) ? 1 : 0)
    d.append("expenses_amount", u.spendingNoTaxes.value);
    d.append("expenses_amount_currency", u.spendingNoTaxes.cur);
    d.append("expenses_frequency", u.periodicity);
    d.append("income_tax", u.taxes.value);
    d.append("income_tax_currency", u.taxes.cur);
    d.append("income_tax_document", null);
    d.append("isf_tax", u.isf.amount);
    d.append("isf_tax_currency", u.isf.cur);
    d.append("isf_document", null);
    d.append(
      "isf_household_share",
      u.taxes.nbFiscalParts ? parseFloat(u.taxes.nbFiscalParts) : 1
    );
    d.append("isf_affiliated_country", u.taxes.countryForTaxes);
    d.append("retirement_month", u.retreat.month);
    d.append(
      "retirement_year",
      u.retreat.year ? parseInt(u.retreat.year) : null
    );
    d.append("has_retirement", u.retreat.hasRetirement);
    d.append("perp_own", u.retreat.PERP.length > 0);
    d.append("profile_influence_description", u.influence.motivation || null);
    d.append("profile_follow_advice", u.follow.rate || null);
    d.append(
      "profile_follow_contract_persons",
      u.follow.nbContractCounselor || null
    );
    d.append(
      "profile_follow_asset_persons",
      u.follow.nbPatrimonialCounselor || null
    );
    d.append("profile_knowledge_diploma", u.knowledge.diploma || null);
    d.append("profile_knowledge_level", u.knowledge.level || null);
    d.append("profile_knowledge_age", u.knowledge.age || null);
    d.append("profile_knowledge_country", u.knowledge.country || null);
    // d.append('profile_knowledge_management', u.knowledge.managements.toString())
    d.append("profile_knowledge_euro", false);
    d.append(
      "profile_investment_perspectives",
      u.perspective.perspective || null
    );
    d.append("profile_risk_degree", u.perspective.riskDegree || null);
    d.append("profile_rising_market", u.perspective.risingMarket || null);
    d.append("profile_assets_estimate", u.perspective.assetsEstimate || null);
    d.append(
      "profile_investment_estimate",
      u.perspective.investmentsEstimate || null
    );
    d.append("interested_by_sustainability", u.esg.interestedBySustainability || false)
    d.append("durability_perf", u.esg.acceptLowerPerformance || false)
    d.append("optin_completion", false);
    d.append("completed", false);
    d.append("overall_debt_percentage", u.overallDebtPercentage);
    return emma.post("api/estate/private/" + u.idUser, d);
  },
  saveKids(u) {
    let data = null;
    if (u.childs.length > 0) {
      data = JSON.stringify({
        kids: u.childs.map((kid) => {
          return {
            id: kid.id,
            type: kid.type,
            firstname: kid.firstname,
            lastname: kid.lastname,
            birthdate: resolveDate(kid.dateOfBirth),
          };
        }),
      });
    } else {
      data = JSON.stringify({ kids: [] });
    }
    return emma.post(
      "api/estate/private/kids/" + u.idUser,
      data,
      "application/json"
    );
  },
  saveSecondaryEstates(u) {
    let data = null;
    if (u.secondaryEstates.length > 0) {
      data = JSON.stringify({
        secondary_residences: u.secondaryEstates.map((se) => {
          return {
            id: se.id,
            value: se.value,
            currency: se.cur,
            ownership_type: se.ownership_type,
          };
        }),
      });
    } else {
      data = JSON.stringify({ secondary_residences: [] });
    }
    return emma.post(
      "api/estate/private/residences/" + u.idUser,
      data,
      "application/json"
    );
  },
  saveRentalProperties(u) {
    let data = null;
    if (u.rentalProperties.length > 0) {
      data = JSON.stringify({
        rental_properties: u.rentalProperties.map((rp) => {
          return {
            id: rp.id,
            value: rp.value,
            currency: rp.cur,
            ownership_type: rp.ownership_type,
          };
        }),
      });
    } else {
      data = JSON.stringify({ rental_properties: [] });
    }
    return emma.post(
      "api/estate/private/rentals/" + u.idUser,
      data,
      "application/json"
    );
  },
  saveSavings(u) {
    let data = null;
    if (u.savings.length > 0) {
      data = JSON.stringify({
        savings: u.savings.map((saving) => {
          let sav = {};
          sav["saving_type"] = saving.type;
          Object.keys(saving.fields).forEach((key) => {
            if (key === "opening_date") {
              if (saving.fields[key].includes(" ")) {
                saving.fields[key] = saving.fields[key].split(" ")[0];
              }
              sav[key] = resolveDate(saving.fields[key]);
            } else {
              sav[key] = saving.fields[key];
            }
          });

          return sav;
        }),
      });
    } else {
      data = JSON.stringify({ savings: [] });
    }
    return emma.post(
      "api/estate/private/savings/" + u.idUser,
      data,
      "application/json"
    );
  },
  saveLoans(u) {
    let data = null;
    if (u.credits.length > 0) {
      data = u.credits.map((loan) => {
        return {
          id: loan.id,
          loan_type: loan.type,
          value: loan.value,
          currency: loan.currency,
          monthly_payment: loan.monthlyPayment,
        };
      });
    } else {
      data = [];
    }
    data = JSON.stringify({ loan: data });
    return emma.post(
      "api/estate/private/loans/" + u.idUser,
      data,
      "application/json"
    );
  },
  savePatrimonialArray(u) {
    let data = {
      perp_type: u.retreat.PERP,
      profile_influence_persons: u.influence.conselors,
      profile_knowledge_product: u.knowledge.products,
      profile_knowledge_invested_product: u.knowledge.investedProducts,
      profile_knowledge_management: u.knowledge.managements,
      profile_investment_objectives: u.perspective.objective,
      durability: u.esg.durabilite
    };
    return emma.post(
      "api/estate/private/" + u.idUser,
      JSON.stringify(data),
      "application/json"
    );
  },
  getInvestisorProfil(id) {
    return emma.get("api/investor-profile/" + id);
  },
};

export default EstateResource;



// WEBPACK FOOTER //
// ./src/common/resources/Estate.js